import React, { useState, useEffect } from 'react';
import { DEVICE } from '@/constants';
import { OS } from '@/utils/detectDevice';

let recorder = null;
const MicDetector = () => {
  const [recording, setRecording] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [playDis, setPlayDis] = useState(true);
  const [recordDis, setRecordDis] = useState(false);

  const recorderStopPlayLocal = () => {
    setPlaying(false);
    setRecordDis(false);
  };

  const startRecordUI = () => {
    setPlayDis(true);
    setRecording(true);
  };

  const recorderResult = ({ src }) => {
    const url = src || recorder.recorder.getSoundUrl();
    setRecording(false);
    setPlayDis(!url);
  };

  const getRecorder = async () => {
    const { default: Recorder } = OS.TYPE === DEVICE.PC
      ? await import('@/utils/recorderPc')
      : await import('@/utils/recorderPhone');
    recorder = new Recorder(
      recorderResult,
      () => {},
      recorderStopPlayLocal,
      () => {},
      startRecordUI,
    );
  };

  useEffect(() => {
    getRecorder();
    return () => recorder.destructor();
  }, []);

  const startPlayMyRecording = () => {
    setPlaying(true);
    setRecordDis(true);
    recorder.play();
  };

  const stopPlayMyRecording = () => recorder.stopPlay();

  const startRecord = () => {
    if (!recording) {
      recorder.start('123');
    } else {
      setRecording(false);
      recorder.stop();
    }
  };

  const play = () => (!playing ? startPlayMyRecording() : stopPlayMyRecording());

  return (
    <div className="mic-wrapper">
      <div className="mic-explain">
        If you can record, your micphone are working fine.
      </div>
      <div className="mic-btn">
        <div className={`record${recording ? ' animation' : ''}${recordDis ? ' dis' : ''}`} onClick={startRecord} />
        <div className={`play${playing ? ' animation' : ''}${playDis ? ' dis' : ''}`} onClick={play}>
          <div className={`${playing && !playDis ? 'playing' : ''}`} />
        </div>
      </div>
    </div>
  );
};

export default MicDetector;
